import React from 'react';

import { Image, StyleSheet } from 'react-native';

import type { OfferListItemProps } from '../types';

type OfferImageProps = Pick<OfferListItemProps, 'image' | 'imageUri' | 'imageAlt'>;

export const OfferImage = ({ image, imageUri, imageAlt }: OfferImageProps) => {
  if (image) {
    return <>{image}</>;
  }

  return (
    <Image
      accessibilityIgnoresInvertColors
      resizeMode="contain"
      source={{
        uri: imageUri,
      }}
      alt={imageAlt}
      style={styles.offerImage}
    />
  );
};

const styles = StyleSheet.create({
  offerImage: {
    height: 112, // $24 or 112 matches
    width: 112,
  },
});
